import React from "react";
import { issueFilter } from "../../js/lib/filters";
import { scrollTo } from "../../js/lib/trip";
import { Issue } from "../../js/headersegment/interfaces";

interface TripIssuesWidgetProps {
    widgetIssues: Issue[];
}

const TripIssuesWidget: React.FC<TripIssuesWidgetProps> = ({ widgetIssues }) => {
    return (
        <div className="widget">
            <div className="header">TRIP ASSIST ISSUES</div>
            <div className="data-header">
                <table className="table table-condensed">
                    <thead>
                        <tr>
                            <th className="left issue-flight">FLIGHT</th>
                            <th className="left issue-type">TYPE</th>
                            <th className="center-value issue-leg">LEG</th>
                            <th className="issue-status">STATUS</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div className="data">
                <table className="table table-condensed">
                    {widgetIssues && widgetIssues.length > 0 ? (
                        <tbody>
                            {widgetIssues.map((issue, index) => (
                                <tr key={index}>
                                    <td className="table-entry issue-flight">
                                        {issue && issue.airline ? (
                                            <span className="flight-number">
                                                {issue.airline.code} {issue.number}
                                            </span>
                                        ) : (
                                            <span className="flight-number">N/A</span>
                                        )}
                                    </td>
                                    <td className="table-entry issue-type">
                                        <a href="#" onClick={(event: any) => scrollTo(`issue-${issue.id}`, event)}>
                                            {issueFilter(issue, 'type')}
                                        </a>
                                    </td>
                                    <td className="table-entry issue-leg center-value">{issue.leg}</td>
                                    <td className="table-entry issue-status">
                                        {issueFilter(issue, 'state')}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td className="none-found" colSpan={4}>No issues.</td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default TripIssuesWidget;